import { render, staticRenderFns } from "./OverwatchNoMap.vue?vue&type=template&id=28fbe804&"
import script from "./OverwatchNoMap.vue?vue&type=script&lang=js&"
export * from "./OverwatchNoMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports